module.exports = ".headers {\n  margin: 0 0 20px 0;\n  font-size: 22px !important;\n  line-height: normal;\n  font-weight: normal;\n  text-transform: uppercase; }\n\nh1, h2, h3, h4, h5, h6, .headers {\n  font-family: Georgia, \"Times New Roman\", Times, serif; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/main/main.component.scss
// module id = ./src/app/modules/common-main/components/main/main.component.scss
// module chunks = main